export const AgeOptions = [
    { label: '< 15 years', value: '< 15 years' },
    { label: '15 - 25 years', value: '15 - 25 years' },
    { label: '26 - 35 years', value: '26 - 35 years' },
    { label: '35 - 45 years', value: '35 - 45 years' },
    { label: '> 50 years', value: '> 50 years' },
];

export const InvestmentExperienceOptions = [
    { label: '< 1 year', value: '< 1 year' },
    { label: '2 - 5 years', value: '2 - 5 years' },
    { label: '5 - 8 years', value: '5 - 8 years' },
    { label: '9 - 10 years', value: '9 - 10 years' },
    { label: '> 10 years', value: '> 10 years' },
];

export const FinancialGoalsOptions = [
    { label: 'Preserving Capital', value: 'Preserving Capital' },
    { label: 'Generating Income', value: 'Generating Income' },
    { label: 'Growing Capital', value: 'Growing Capital' },
    { label: 'Maximizing Tax efficiency', value: 'Maximizing Tax efficiency' },
];

export const TimeHorizonOptions = [
    { label: 'Short Term', value: 'Short Term' },
    { label: 'Medium Term', value: 'Medium Term' },
    { label: 'Long Term', value: 'Long Term' },
];

export const RiskToleranceOptions = [
    { label: 'Low', value: 'Low' },
    { label: 'Medium', value: 'Medium' },
    { label: 'High', value: 'High' },
];

export const ReturnExpectationsOptions = [
    { label: 'Conservative', value: 'Conservative' },
    { label: 'Moderate', value: 'Moderate' },
    { label: 'Aggressive', value: 'Aggressive' },
];

export const ModelVersionOptions = [
    { label: 'ESG-Compliant', value: 'ESG-Compliant' },
    { label: 'Income-Focused', value: 'Income-Focused' },
    { label: 'Tax-Optimized', value: 'Tax-Optimized' },
];
